import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyAmount: {
        id: 'ent.setupautopay.makeapayment.Empty Amount',
        defaultMessage: '-',
    },
    vendorFee: {
        id: 'ent.setupautopay.makeapayment.Vendor Fee Label',
        defaultMessage: "Estimated Vendor Fee:"
    },
    vendorFeeWithRate: {
        id: 'ent.setupautopay.makeapayment.Vendor Fee Label With Rate',
        defaultMessage: "Estimated Vendor Fee ({feeRate}%):"
    },
    tbd: {
        id: 'twia.setupautopay.TBD',
        defaultMessage: "TBD"
    },
    errorInProcessingPayment: {
        id: 'twia.setupautopay.Error in processing the payment',
        defaultMessage: 'Error in processing the payment'
    },
    paymentSystemUnavailable: {
        id: 'twia.setupautopay.Payment System Unavailable.Title',
        defaultMessage: 'Payment System Unavailable'
    },
    paymentSystemUnavailbleBody: {
        id: 'twia.setupautopay.Payment System Unavailable.Body',
        defaultMessage: 'The online payment system is currently unavailable. Please check back later.'
    },
    cardDeclinedTitle: {
        id: 'twia.setupautopay.Card Declined Title',
        defaultMessage: 'Your Card was Declined'
    },
    cardDeclinedBody:{
        id: 'twia.setupautopay.Card Declined Body',
        defaultMessage: 'Please verify your card information. If the problem persists, please contact your card issuer.'
    },
    duplicatePaymentNotProcessedBody: {
        id:'twia.setupautopayDuplicate Payment Not Processed Body',
        defaultMessage:'A transaction for this amount ({amount}) was already processed today'
    },
    unableToCompletePaymentTitle: {
        id: 'twia.setupautopay.Unable To Complete Payment Title',
        defaultMessage: 'Your Payment Cannot Be Processed'
    },
    unableToCompleteBody: {
        id: 'twia.setupautopay.Unable To Complete Payment Body',
        defaultMessage: 'Please try again later'
    },
    turnOffAutoPayBody:{
        id: 'twia.setupautopay.Turn Off Auto Pay Body',
        defaultMessage: 'Are you sure you wish to turn off Auto Pay? Your payments will no longer be drafted automatically.'
    },
    turnOffAutoPayBodyWithAutoDraftPlan: {
        id: 'twia.setupautopay.Turn Off Auto Pay Body With AutoDraft Plan',
        defaultMessage: 'Auto Pay is required for the TWIA 10 Pay Plan. If Auto Pay is turned off, the TWIA 10 Pay Plan will not be available for the remainder of this policy term and your payment plan will be changed to the TWIA 4 Pay Plan.'
    },
    confirmTurnOffAutoPayBody: {
        id: 'twia.billing.directives.autopay.Confirm Turn Off Auto Pay Body',
        defaultMessage: 'Auto Pay has been turned off for Policy {policy}.'
    },
    confirmTurnOffAutoPaySubject: {
        id: 'twia.billing.directives.autopay.Confirm Turn Off Auto Pay Subject',
        defaultMessage: 'Auto Pay Turned Off'
    },
    cancelAutoPaySetupTitle: {
        id: 'twia.billing.directives.autopay.Cancel Auto Pay Setup Title',
        defaultMessage: 'Cancel Auto Pay Setup?'
    },
    cancelAutoPaySetupBody: {
        id: 'twia.billing.directives.autopay.Cancel Auto Pay Setup Body',
        defaultMessage: 'Are you sure you wish to cancel setting up auto pay?'
    },
    confirmAutoPay: {
        id: 'twia.billing.directives.autopay.Confirm Auto Pay Setup Title',
        defaultMessage: 'Confirm Auto Pay?'
    },
    confirmAutoPaySetupBody: {
        id: 'twia.billing.directives.autopay.Confirm Auto Pay Setup Body',
        defaultMessage: 'By confirming Auto Pay, you are authorizing TWIA to draft a payment from your account for any currently due and past due invoices.'
    },
    editAutomaticPaymentMethod: {
        id: 'twia.billing.directives.autopay.Edit Automatic Payment Method',
        defaultMessage: 'Edit Automatic Payment Method'
    },
    anyChangesToAutoPay: {
        id: 'twia.billing.directives.autopay.Any changes to Auto Pay will be reflected on the Next Draft Date',
        defaultMessage: 'Any changes to Auto Pay will be reflected on the Next Draft Date.'
    },
    cancelAutoPayEditTitle: {
        id: 'twia.billing.directives.autopay.Cancel Auto Pay Edit Title',
        defaultMessage: 'Cancel Editing Auto Pay?'
    },
    cancelAutoPayEditBody : {
        id: '"twia.billing.directives.autopay.Cancel Auto Pay Edit Body',
        defaultMessage: 'Are you sure you wish to cancel editing Auto Pay? Any changes you made will be lost.'
    },
    confirmAutoPayEditTitle: {
        id: 'twia.billing.directives.autopay.Confirm Auto Pay Edit Title',
        defaultMessage: 'Confirm Auto Pay Updates?'
    },
    confirmAutoPayEditBody: {
        id: 'twia.billing.directives.autopay.Confirm Auto Pay Edit Body',
        defaultMessage: 'By confirming Auto Pay, you are authorizing TWIA to draft a payment from your account for any currently due and past due invoices.'
    },
    turnOffAutoPayTitle: {
        id: 'twia.billing.directives.autopay.Turn Off Auto Pay Title',
        defaultMessage: 'Turn Off Auto Pay?'
    },
    updateAutoPay: {
        id: 'twia.billing.directives.autopay.Update Auto Pay',
        defaultMessage: 'Update Auto Pay'
    },
    turnOnAutoPay: {
        id: 'twia.billing.directives.autopay.Turn On Auto Pay',
        defaultMessage: 'Turn On Auto Pay'
    },
    byConfirmingAutoPay: {
        id: 'twia.billing.directives.autopay.By confirming Auto Pay, you are ...',
        defaultMessage: 'By confirming Auto Pay, you are authorizing TWIA to draft a payment from your account for any currently due or past due invoices.'
    },
    invoicesWillbeDraftedImmediately: {
        id: '"twia.billing.directives.autopay.Any past due invoices will be drafted immediately',
        defaultMessage: 'Any past due invoices will be drafted immediately.'
    },
    futurePaymentsDraftedOnInvoiceDueDate: {
        id: 'twia.billing.directives.autopay.Future payments will be drafted on the Invoice Due Date',
        defaultMessage: 'Future payments will be drafted on the Invoice Due Date.'
    }

});
